export const manager = {
  hero: {
    title: {
      pt1: 'An',
      pt2: 'intuitive manager',
      pt3: 'to always stay on top of your game'
    },
    description: 'Bistroo\'s Manager app allows you to make adjustments to your Webshop and Website in a matter of seconds. Handle every order with ease, and always be in control of your online orders.',
    button: 'View manager'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Real-time control of your online store',
      text: 'Maintain the perfect serving of customer experience. Adjust all of your settings in realtime through the Bistroo Manager App. Accessible on all of your devices, from any location.',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_2: {
      title: 'Picture perfect delivery settings',
      text: 'Perfectly align your delivery or take-away limits with your capabilities of a particular day, and picture perfectly draw your desired areas on Google Maps. With the possibility to adjust your terms & conditions per delivery area configured.',
      cta: ''
    },
    paragraph_3: {
      title: 'Insights & Reporting',
      text: 'Advanced insights and reporting are available through the Manager app. Make adjustments to your terms & conditions based on data-driven decision making and suggestions made by the Manager AI.',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_4: {
      title: 'Streamline your operations',
      text: 'Save precious time and manual labor, but never get surprised by orders or unexpected online volume! You maintain or manually adjust your peak-time volume and order ETA’s with a simple click of the button. Stay in control, at all times.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Adjust your menu and settings, with ease.',
        text: 'Adjust your restaurant’s menu, terms and settings from any location. Access the Manager from any device, at any time. Change products, prices, inventory, discounts, promotions and delivery area’s with ease.',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integrations.',
        text: 'Explore our app marketplace for a the different third-party integrations',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Manage multiple locations.',
        text: 'Easily manage multiple locations, if applicable for your business.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Track payments.',
        text: 'Or process refunds. The average refund rate is only 0,2% though.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Reporting & Analytics.',
        text: 'Analyse your online performance with basic and advanced reporting options.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"The Manager and Products keep evolving—so fun to watch the progress and be part of it!"',
    cta: 'Read Istanbul\'s story',
    name: 'Istanbul Grillroom',
    job_title: 'Grillroom'
  }
}